import React from 'react';
import cx from 'classnames';
import { FormControl, InputLabel, TextField } from '@mui/material';
import css from './Input.module.scss';

type TInput = {
  value: string;
  width?: string;
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
  label?: string;
  onChange: (value: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  type?: 'text' | 'password';
  disabled?: boolean;
};

export const Input = ({
  value,
  label,
  placeholder,
  onChange,
  multiline,
  rows,
  type = 'text',
  width = '150px',
  disabled,
}: TInput) => {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      {label && <div className={css.label}>{label}</div>}
      {placeholder && (
        <InputLabel className={cx(css.placeholder, (isFocused || value) && css.isFocused)}>
          {placeholder}
        </InputLabel>
      )}
      <TextField
        className={cx(css.root, multiline && css.multiline)}
        onChange={onChange}
        variant="outlined"
        size="small"
        style={{ width, fontWeight: 'normal' }}
        type={type}
        multiline={multiline}
        value={value}
        rows={rows}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
      />
    </FormControl>
  );
};
